export interface Category {
  id: number;
  name?: string;
  state?: string;
  order?: number;
  guid?: string;
  class?: string;
  icon?: string;
  color?: string;
}
